export const MAX_DEVICE_SEARCH_RETRIES = 20;
export const MAX_HUB_SEARCH_RETRIES = 20;
